const ETHEREUM_MAINNET_CHAIN_ID = 1;
const ETHEREUM_SEPOLIA_CHAIN_ID = 11155111;
const BASE_MAINNET_CHAIN_ID = 8453;
const BASE_SEPOLIA_CHAIN_ID = 84532;

const MAINNET_EAS_SCAN_ORIGIN = 'https://easscan.org';
const SEPOLIA_EAS_SCAN_ORIGIN = 'https://sepolia.easscan.org';
const BASE_MAINNET_EAS_SCAN_ORIGIN = 'https://base.easscan.org';
const BASE_SEPOLIA_EAS_SCAN_ORIGIN = 'https://base-sepolia.easscan.org';

type ChainLike = number | string | bigint | null | undefined;

const normalizeChainId = (chainId: ChainLike): number | null => {
  if (chainId === null || chainId === undefined) {
    return null;
  }

  if (typeof chainId === 'number' && Number.isFinite(chainId)) {
    return Math.trunc(chainId);
  }

  if (typeof chainId === 'bigint') {
    return Number(chainId);
  }

  if (typeof chainId === 'string') {
    const trimmed = chainId.trim();
    if (!trimmed) {
      return null;
    }

    if (trimmed.startsWith('0x') || trimmed.startsWith('0X')) {
      const parsedHex = Number.parseInt(trimmed, 16);
      return Number.isNaN(parsedHex) ? null : parsedHex;
    }

    const parsed = Number.parseInt(trimmed, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  return null;
};

export const getEasScanOrigin = (chainId?: ChainLike): string => {
  const normalizedChainId = normalizeChainId(chainId);
  if (normalizedChainId === BASE_MAINNET_CHAIN_ID) {
    return BASE_MAINNET_EAS_SCAN_ORIGIN;
  }

  if (normalizedChainId === BASE_SEPOLIA_CHAIN_ID) {
    return BASE_SEPOLIA_EAS_SCAN_ORIGIN;
  }

  if (normalizedChainId === ETHEREUM_SEPOLIA_CHAIN_ID) {
    return SEPOLIA_EAS_SCAN_ORIGIN;
  }

  // Default to Ethereum mainnet for unknown/unsupported chains.
  return MAINNET_EAS_SCAN_ORIGIN;
};

export const getEasAttestationUrl = (attestationUID: string, chainId?: ChainLike): string => {
  return `${getEasScanOrigin(chainId)}/attestation/view/${attestationUID}`;
};

export const getEasGraphqlUrl = (chainId?: ChainLike): string => {
  return `${getEasScanOrigin(chainId)}/graphql`;
};

export const getEasSchemaCreateUrl = (chainId?: ChainLike): string => {
  return `${getEasScanOrigin(chainId)}/schema/create`;
};

export const EAS_SUPPORTED_CHAIN_IDS = [
  ETHEREUM_MAINNET_CHAIN_ID,
  ETHEREUM_SEPOLIA_CHAIN_ID,
  BASE_MAINNET_CHAIN_ID,
  BASE_SEPOLIA_CHAIN_ID,
] as const;